import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import React from 'react';
import PropTypes from "prop-types";
import { css } from '@emotion/react';
import { useEuiTheme } from '../../../../../src/services';
import { EuiCode, EuiColorPickerSwatch } from '../../../../../src';
import { EuiThemeBorderColorValues, EuiThemeBorderRadiusValues, EuiThemeBorderTypes, EuiThemeBorderWidthValues } from '../_props';
import { getPropsFromComponent } from '../../../services/props/get_props';
import { ThemeExample } from '../_components/_theme_example';
import { ThemeValuesTable } from '../_components/_theme_values_table';
import { getDescription } from '../../../services/props/get_description';
export var TypesJS = function TypesJS(_ref) {
  var description = _ref.description;
  var _useEuiTheme = useEuiTheme(),
    euiTheme = _useEuiTheme.euiTheme;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeExample, {
    title: ___EmotionJSX("code", null, "euiTheme.border[type]"),
    description: description,
    example: ___EmotionJSX("div", {
      css: /*#__PURE__*/css("padding:", euiTheme.size.s, ";border:", euiTheme.border.thin, ";;label:TypesJS;")
    }, ___EmotionJSX("strong", null, "border: ".concat(euiTheme.border.thin))),
    snippet: 'border: ${euiTheme.border.thin};',
    snippetLanguage: "emotion"
  }));
};
TypesJS.propTypes = {
  description: PropTypes.node
};
export var TypesValuesJS = function TypesValuesJS() {
  var _useEuiTheme2 = useEuiTheme(),
    euiTheme = _useEuiTheme2.euiTheme;
  var typeProps = getPropsFromComponent(EuiThemeBorderTypes);
  var types = Object.keys(typeProps);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeValuesTable, {
    items: types.map(function (type) {
      return {
        id: type,
        token: "border.".concat(type),
        type: typeProps[type],
        value: euiTheme.border[type]
      };
    }),
    render: function render(item) {
      return ___EmotionJSX(EuiColorPickerSwatch, {
        color: euiTheme.colors.emptyShade,
        disabled: true,
        css: [/*#__PURE__*/css("border:", item.value, ";;label:TypesValuesJS;"), ";label:TypesValuesJS;"]
      });
    }
  }));
};
export var ColorJS = function ColorJS(_ref2) {
  var description = _ref2.description;
  var _useEuiTheme3 = useEuiTheme(),
    euiTheme = _useEuiTheme3.euiTheme;
  var colorProps = getPropsFromComponent(EuiThemeBorderColorValues);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeExample, {
    title: ___EmotionJSX("code", null, "euiTheme.border.color"),
    description: ___EmotionJSX(React.Fragment, null, getDescription(colorProps.color), description),
    example: ___EmotionJSX("div", {
      css: /*#__PURE__*/css("padding:", euiTheme.size.s, ";border-width:1px;border-style:solid;border-color:", euiTheme.border.color, ";;label:ColorJS;")
    }, ___EmotionJSX("strong", null, "border-color: ".concat(euiTheme.border.color))),
    snippet: 'border-color: ${euiTheme.border.color};',
    snippetLanguage: "emotion"
  }));
};
ColorJS.propTypes = {
  description: PropTypes.node
};
export var ColorValuesJS = function ColorValuesJS() {
  var _useEuiTheme4 = useEuiTheme(),
    euiTheme = _useEuiTheme4.euiTheme;
  var colorProps = getPropsFromComponent(EuiThemeBorderColorValues);
  var types = Object.keys(colorProps);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeValuesTable, {
    items: types.map(function (type) {
      return {
        id: type,
        token: "border.".concat(type),
        type: colorProps[type],
        value: euiTheme.border[type]
      };
    }),
    render: function render(item) {
      return ___EmotionJSX(EuiColorPickerSwatch, {
        color: item.value,
        disabled: true
      });
    }
  }));
};
export var WidthJS = function WidthJS(_ref3) {
  var description = _ref3.description;
  var _useEuiTheme5 = useEuiTheme(),
    euiTheme = _useEuiTheme5.euiTheme;
  var wrappingExampleStyle = {
    padding: euiTheme.size.s
  };
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeExample, {
    title: ___EmotionJSX("code", null, "euiTheme.border.width[size]"),
    description: ___EmotionJSX("p", null, description, ___EmotionJSX(EuiCode, null, "border.color"), "."),
    example: ___EmotionJSX("div", {
      style: wrappingExampleStyle,
      css: /*#__PURE__*/css("border:", euiTheme.border.width.thick, " dashed ", euiTheme.border.color, ";;label:WidthJS;")
    }, ___EmotionJSX("strong", null, "border: ".concat(euiTheme.border.width.thick, " dashed ").concat(euiTheme.border.color))),
    snippet: 'border: ${euiTheme.border.width.thick} dashed ${euiTheme.border.color};',
    snippetLanguage: "emotion"
  }));
};
WidthJS.propTypes = {
  description: PropTypes.node
};
export var WidthValuesJS = function WidthValuesJS() {
  var _useEuiTheme6 = useEuiTheme(),
    euiTheme = _useEuiTheme6.euiTheme;
  var widthProps = getPropsFromComponent(EuiThemeBorderWidthValues);
  var widths = Object.keys(widthProps);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeValuesTable, {
    items: widths.map(function (type) {
      return {
        id: type,
        token: "border.width.".concat(type),
        type: widthProps[type],
        value: euiTheme.border.width[type]
      };
    }),
    render: function render(item) {
      return ___EmotionJSX(EuiColorPickerSwatch, {
        color: euiTheme.colors.emptyShade,
        disabled: true,
        css: /*#__PURE__*/css("border:", euiTheme.border.thick, ";border-width:", item.value, ";;label:WidthValuesJS;")
      });
    }
  }));
};
export var RadiusJS = ({
  description
}) => {
  const {
    euiTheme
  } = useEuiTheme();
  return <>
      <ThemeExample title={<code>euiTheme.border.radius[size]</code>} description={description} example={<div css={/*#__PURE__*/css("padding:", euiTheme.size.s, ";border:", euiTheme.border.thick, ";border-radius:", euiTheme.border.radius.medium, ";;label:RadiusJS;")}>
            <strong>{`border-radius: ${euiTheme.border.radius.medium}`}</strong>
          </div>} snippet={'border-radius: ${euiTheme.border.radius.medium};'} snippetLanguage="emotion" />
    </>;
};
RadiusJS.propTypes = {
  description: PropTypes.node
};
export const RadiusValuesJS = () => {
  const {
    euiTheme
  } = useEuiTheme();
  const radiusProps = getPropsFromComponent(EuiThemeBorderRadiusValues);
  const radii = Object.keys(radiusProps);
  return <>
      <ThemeValuesTable items={radii.map(type => {
      return {
        id: type,
        token: `border.radius.${type}`,
        type: radiusProps[type],
        value: euiTheme.border.radius[type]
      };
    })} render={item => <EuiColorPickerSwatch color={euiTheme.colors.emptyShade} disabled css={/*#__PURE__*/css("border:", euiTheme.border.thick, ";border-radius:", item.value, ";;label:RadiusValuesJS;")} />} />
    </>;
};
try {
  TypesJS.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/borders/_border_js.tsx',
    description: '',
    displayName: 'TypesJS',
    methods: [],
    props: {
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src-docs/src/views/theme/_props.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'React.ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}
try {
  ColorJS.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/borders/_border_js.tsx',
    description: '',
    displayName: 'ColorJS',
    methods: [],
    props: {
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src-docs/src/views/theme/_props.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'React.ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}
try {
  WidthJS.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/borders/_border_js.tsx',
    description: '',
    displayName: 'WidthJS',
    methods: [],
    props: {
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src-docs/src/views/theme/_props.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'React.ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}
try {
  RadiusJS.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/borders/_border_js.tsx',
    description: '',
    displayName: 'RadiusJS',
    methods: [],
    props: {
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src-docs/src/views/theme/_props.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'React.ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}